import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { LoginForm } from '../../components/auth/LoginForm';
import AuthLayout from '../../components/auth/AuthLayout';

export default function LoginPage() {
  const [error, setError] = useState<string | null>(null);
  const login = useAuthStore((state) => state.login);
  const navigate = useNavigate();

  const handleLogin = async (email: string, password: string) => {
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred during login. Please try again.');
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <AuthLayout 
      title="Welcome back" 
      subtitle="Sign in to access your dashboard"
    >
      <LoginForm 
        onSubmit={handleLogin} 
        error={error} 
        onForgotPassword={handleForgotPassword}
      />
      
      <div className="mt-4 text-center space-y-2">
        <p className="text-sm text-gray-600">
          Don't have an account?{' '}
          <Link to="/signup" className="text-blue-500 hover:text-blue-600">
            Sign up
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}